<script>
import Popin from "@/components/molecules/popin";
import Button from "@/components/atoms/button";
import Badge from "@/components/atoms/badge";
import Icon from "@/components/atoms/icon";

export default {
  name: "PopinActivationServicePrive",
  components: { Popin, Button, Badge, Icon },
  props: {
    nomRetrait: {
      type: String,
      required: true
    },
    nomMagasin: {
      type: String,
      required: false,
      default: null
    }
  },
  methods: {
    show() {
      this.$refs.popin.show();
    },
    hide() {
      this.$refs.popin.hide();
    },
    goToProfil() {
      this.hide();
      navigateToInternal("/mon-compte/mon-profil");
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    aria-label="Compte activé"
  >
    <div class="u-text-center">
      <Badge
        variant="success"
        circle
        size="xlg"
        class="u-mb-sm"
      >
        <Icon
          name="check"
          variant="white"
        />
      </Badge>
      <h1 class="u-font-secondary u-color-primary u-font-24 u-font-700 u-text-center u-mb-sm">
        Votre compte vient d'être activé pour le retrait à : {{ nomRetrait }}
      </h1>
      <p
        v-if="nomMagasin"
        class="u-mb-md"
      >
        Ce retrait est disponible dans le magasin <strong>{{ nomMagasin }}</strong>.
      </p>
      <p>
        Vous souhaitez être informé(e) par SMS de l'état de vos commandes? <br>
        Pour bénéficier de ce service gratuit, c'est simple, cochez la case dans "Mes informations personnelles.
      </p>
    </div>
    <div class="u-flex u-flex-justify-center u-mt-lg">
      <Button
        variant="primary"
        radius="full"
        size="md"
        @click="goToProfil()"
      >
        J'accède à mes informations
      </Button>
    </div>
  </Popin>
</template>

<style lang="scss" scoped>
</style>
